export default {
    baseStyle: {
        heading: {
            fontSize: '18px',
            fontWeight: 400,
            fontFamily: 'cormorant',
            marginBottom: 1
        },
        calloutMessage: {
            fontFamily: 'inter',
            fontWeight: 300,
            fontSize: '13px',
            marginBottom: '8px'
        },
        container: {
            maxWidth: '300px',
            height: '153px',
            color: 'black.300',
            position: 'relative',
            marginTop: '30px',
            borderRadius: '5px',
            boxShadow: '-7px 5px 5px 0px rgba(34, 34, 34, 0.07)'
        },
        button: {
            fontWeight: 400,
            fontSize: '13px',
            textDecoration: 'underline',
            backgroundColor: 'transparent',
            borderRadius: 0,
            color: 'green.600',
            border: 'none',
            padding: 0,
            height: 'unset',
            lineHeight: 'normal',
            _hover: {
                backgroundColor: 'transparent',
                border: 'none',
                color: 'green.600'
            },
            _disabled: {
                backgroundColor: 'transparent'
            }
        },
        errorText: {
            color: 'red.400',
            fontSize: '13px',
            fontWeight: 300,
            fontFamily: 'inter',
            marginLeft: '10px'
        }
    }
}
